import React, { useState } from 'react';
import { Eyebrow } from './LeafMark';

export default function FAQAccordion({ titulo, items }) {
  const [abierto, setAbierto] = useState(null);
  if (!items?.length) return null;
  return (
    <div style={{ padding: '32px 20px', maxWidth: 640, margin: '0 auto' }}>
      {titulo && <Eyebrow>{titulo}</Eyebrow>}
      {items.map((f, i) => (
        <div key={i} style={{ borderBottom: '1px solid rgba(28,58,30,0.1)' }}>
          <button onClick={() => setAbierto(abierto === i ? null : i)} style={{
            width: '100%', textAlign: 'left', background: 'none', border: 'none', padding: '14px 4px',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer',
            fontWeight: 700, fontSize: 14, color: 'var(--forest)', fontFamily: 'var(--font-body)',
          }}>
            {f.question}
            <span style={{ fontSize: 18, transform: abierto === i ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s' }}>+</span>
          </button>
          {abierto === i && (
            <p style={{ fontSize: 13, color: 'var(--ink-light)', lineHeight: 1.6, padding: '0 4px 16px', margin: 0 }}>{f.answer}</p>
          )}
        </div>
      ))}
    </div>
  );
}
